import type { ExecutableToken, SwapableToken, BalanceMap, } from "./types"
export const executableTokens: ExecutableToken[] = [ "stETH", "eETH", "rETH", "ezETH" ];
export const SwappableToken: SwapableToken[] = [ "ETH" ];
export const balances: BalanceMap = new Map([
	[ "stETH", BigInt(0), ],
	[ "eETH", BigInt(0), ],
	[ "rETH", BigInt(0), ],
	[ "ezETH", BigInt(0), ],
])
export { coinMap } from "../../assets/icons/coins";
